import React from 'react';
import { Container } from 'vendors/semantic-ui';

import { TitleBlocContainer, DescriptionContainer, MentionContainer } from 'modules/shared-cms-advanced/components';
import { getDefault } from 'modules/shared-cms/utils';
import { getNestedReferenceId } from 'modules/shared-cms-advanced/utils';
import { Showroom } from 'modules/shared-cms-advanced/enhanced-blocs';

import { FilterableDressList } from '../../components';
import { DressesProps } from './dresses-type';

import enhancer from './dresses-enhancer';
import styles from './dresses-page.module.css';

export const InnerDressesPage: React.FC<DressesProps> = React.memo(({ content, ...rest }: DressesProps) => {
    const wrappedShowroomId = getDefault(getNestedReferenceId(content.data.showroom), '');
    const { ...datarest } = content.data;

    return (
        <React.Fragment>
            <div className={`${styles.root} full-height full-width`}>
                <div className={styles.titleBlocSection}>
                    <TitleBlocContainer {...datarest} />
                </div>
                <div className={styles.descriptionSection}>
                    <Container>
                        <div className={styles.descriptionText}>
                            <DescriptionContainer {...datarest} />
                        </div>
                    </Container>
                </div>
                <Container>
                    <FilterableDressList {...rest} />
                    <div className={styles.mentionSection}>
                        <MentionContainer {...datarest} />
                    </div>
                </Container>
                {wrappedShowroomId && <Showroom id={wrappedShowroomId} />}
            </div>
        </React.Fragment>
    );
});

export const DressesPage = enhancer(InnerDressesPage);
